import { useQuery } from "@tanstack/react-query";
import { settingsQuery } from "@/lib/queries";

export type SiteSettings = any;

function parseVal(v: any): string {
  if (v == null) return "";
  if (typeof v === "string") return v;
  return String(v);
}

export function useSiteSettings() {
  const { data } = useQuery(settingsQuery());
  const s = (data ?? {}) as SiteSettings;
  return {
    candidateName: parseVal(s.candidate_name) || "Professor Rurdiney",
    candidateNumber: parseVal(s.candidate_number) || "40123",
    slogan: parseVal(s.slogan),
    office: parseVal(s.office) || "Vereador",
    city: parseVal(s.city),
    state: parseVal(s.state),
    email: parseVal(s.email),
    phone: parseVal(s.phone),
    whatsapp: parseVal(s.whatsapp),
    address: parseVal(s.address),
    heroTitle: parseVal(s.hero_title),
    heroSubtitle: parseVal(s.hero_subtitle),
    heroTagline: parseVal(s.hero_tagline),
    instagram: parseVal(s.instagram),
    facebook: parseVal(s.facebook),
    youtube: parseVal(s.youtube),
    tiktok: parseVal(s.tiktok),
    logoUrl: parseVal(s.logo_url),
    logoLightUrl: parseVal(s.logo_light_url),
    heroPhotoUrl: parseVal(s.hero_photo_url),
    heroBgUrl: parseVal(s.hero_bg_url),
    pageHeroBgUrl: parseVal(s.page_hero_bg_url),
    footerText: parseVal(s.footer_text),
    cnpj: parseVal(s.cnpj),
    raw: s,
  };
}
